import alt from '../alt';
import leaveAction from '../actions/leaveAction';

class leaveStore {
    constructor() {
        this.bindActions(leaveAction);
        this.search = "";
        this.processing = false;
        this.startYear = new Date().getFullYear();
        this.startMonth = new Date().getMonth();
        this.endYear = new Date().getFullYear();
        this.endMonth = new Date().getMonth();
        this.isLeaveSuccess = false;
        this.warningMsg = '';
        this.staffId = "";

        this.leaves = [];
        /*
            { _id: "1234", date: new Date(), submittedBy: "Ho Kok Liang", startDate: new Date(), endDate: new Date(), apmStart: 0, apmEnd: 0, type: 1, duration: 2.5, status: 0, leaveImage: "/public/img/profile-pic.jpg" },
            { _id: "1236", date: new Date(), submittedBy: "Loh Jik Nen", startDate: new Date(), endDate: new Date(), apmStart: 1, apmEnd: 0, type: 0, duration: 2.5, status: 1 },
            { _id: "1237", date: new Date(), submittedBy: "Tan Kai Lee", startDate: new Date(), endDate: new Date(), apmStart: 2, apmEnd: 0, type: 4, duration: 2.5, status: 0, remark: "remark 1" },
            { _id: "1239", date: new Date(), submittedBy: "Tan Kai Lee", startDate: new Date(), endDate: new Date(), apmStart: 0, apmEnd: 0, type: 0, duration: 2.5, status: 0 },
        */
        this.summary = {};
        /*
            staffId: "1234",
            userName: "Ho Kok Liang",
            summary: [
                { type: 0, bringFwd: 4.0, leaveGain: 3.0, used: 2.0 },
                { type: 1, bringFwd: 0.0, leaveGain: 3.0, used: 0.0 },
                { type: 2, bringFwd: 4.0, leaveGain: 3.0, used: 2.0 },
                { type: 3, bringFwd: 4.0, leaveGain: 3.0, used: 2.0 },
                { type: 4, bringFwd: 0, leaveGain: 0, used: 2.0 },
                { type: 5, bringFwd: 4.0, leaveGain: 3.0, used: 2.0 },
                { type: 6, bringFwd: 0, leaveGain: 0, used: 0 },
                { type: 7, bringFwd: 0, leaveGain: 0, used: 0 },
                { type: 8, bringFwd: 0, leaveGain: 0, used: 0 },
                
            ]
        */
        /*
        "Annual Leave", 
        "Medical Leave", 
        "Reservist", 
        "Childcare leave", 
        "Unpaid leave", 
        "Compassionate leave",
        "Other Leave", 
        "Time-off", 
        "Tele-commuting",
            */
    }
    onProcessing(data) {
        this.processing = data;
    }
    onUploadMCSuccess(data){
        let len = this.leaves.length;
        for(let i = 0 ; i < len ; i++){
            if(this.leaves[i]._id == data._id){
                this.leaves[i].leaveImage = data.leaveImage;
            }
        }
    }
    uploadRPSuccess(data){
        let len = this.leaves.length;
        for(let i = 0 ; i < len ; i++){
            if(this.leaves[i]._id == data._id){
                this.leaves[i].receiptImage = data.receiptImage;
            }
        }
    }
    onGetLASuccess(data) {
        this.leaves = data;
    }
    onUpdateSM(data) {
        this.startYear = data.startYear;
        this.startMonth = data.startMonth;
    }
    onUpdateEM(data) {
        this.endMonth = data.endMonth;
        this.endYear = data.endYear;
    }
    onUpdateUI(data) {
        this.staffId = data.staffId;
    }
    onClear(){
        this.leaves = [];
    }
    onSummaryClear(){
        this.summary = {};
    }
    onSearch(data) {
        this.search = data;
    }
    onSummarySuccess(data) {
        this.summary = data;
    }
    onShouldListShow(data) {
        this.leaves[data].shouldListShow = !this.leaves[data].shouldListShow;
    }
    onCloseListShow(){
        if(this.leaves){
            for(let i = 0 ; i< this.leaves.length ; i++){
                this.leaves[i].shouldListShow = false;
            }
        }
    }
    onChangeStatusSuccess(data) {
        let len = this.leaves.length;
        for (let i = 0; i < len; i++) {
            if (this.leaves[i]._id == data._id) {
                this.leaves[i].status = data.status;
                break;
            }
        }
    }
    onIsLeaveSuccess(data){
        this.isLeaveSuccess = data;
    }
}
export default alt.createStore(leaveStore, 'leaveStore');


// WEBPACK FOOTER //
// ./app/stores/leaveStore.js